import React, { createContext, useContext, useMemo, useState } from "react";

import { TermLifePlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: TermLifePlan;
  planCost: PlanCost;
}
interface TermLifeContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: TermLifePlan | null;
  planCost: PlanCost | null;
  selectedEmployeeAmount?: number | null;
  selectedSpouseAmount?: number | null;
  selectedChildAmount?: number | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const TermLifeContext = createContext<TermLifeContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: TermLifePlan;
  planCost: PlanCost;
  selectedEmployeeAmount?: number | null;
  selectedSpouseAmount?: number | null;
  selectedChildAmount?: number | null;
}
export const TermLifeContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<TermLifePlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const [_selectedEmployeeAmount, _setSelectedEmployeeAmount] = useState<number | null>(null);
  const [_selectedSpouseAmount, _setSelectedSpouseAmount] = useState<number | null>(null);
  const [_selectedChildAmount, _setSelectedChildAmount] = useState<number | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost, selectedEmployeeAmount, selectedSpouseAmount, selectedChildAmount }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      _setSelectedEmployeeAmount(selectedEmployeeAmount);
      _setSelectedSpouseAmount(selectedSpouseAmount);
      _setSelectedChildAmount(selectedChildAmount);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      _setSelectedEmployeeAmount(null);
      _setSelectedSpouseAmount(null);
      _setSelectedChildAmount(null);
      hide();
    };
    return {
      openEnrollmentModal,
      plan: _plan,
      planCost: _planCost,
      selectedEmployeeAmount: _selectedEmployeeAmount,
      selectedSpouseAmount: _selectedSpouseAmount,
      selectedChildAmount: _selectedChildAmount,
      isShowing,
      hideEnrollmentModal,
    };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <TermLifeContext.Provider value={contextValue}>{children}</TermLifeContext.Provider>;
};

export const useTermLifeContext = () => useContext(TermLifeContext);
